import Countdown from 'react-countdown'

import { SUMMER_DEAL_END } from '../consts.ts'
import { TimeBox } from './TimeBox.tsx'

export const SummerDealCountdown = () => {
  return (
    <div className="mt-0 hidden lg:mt-[-6px] lg:block">
      <span className="text-xs">Time left</span>
      <Countdown
        intervalDelay={1000}
        autoStart
        date={SUMMER_DEAL_END}
        className=""
        renderer={(left) => {
          return (
            <div className="flex items-center rounded-md bg-primary-800 text-white">
              <TimeBox text={`${left.days}d`} />
              <span className="text-whte mx-1 inline-block text-sm font-medium">
                :
              </span>
              <TimeBox text={left.formatted.hours} />
              <span className="mx-1 inline-block text-sm font-medium text-white">
                :
              </span>
              <TimeBox text={left.formatted.minutes} />
            </div>
          )
        }}
      />
    </div>
  )
}
